var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWrapper", [
    _c("div", [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newCatName,
                expression: "newCatName"
              }
            ],
            staticClass: "form-control mr-3",
            staticStyle: { width: "calc(100% - 73px)" },
            attrs: { type: "text", name: "anniversary" },
            domProps: { value: _vm.newCatName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newCatName = $event.target.value
              }
            }
          }),
          _c("b-button-group", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary mb-2",
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_vm._v("추가")]
            )
          ])
        ],
        1
      ),
      _c("div", { staticClass: "card card-default book-list" }, [
        _c(
          "div",
          {
            staticClass: "card-body",
            staticStyle: { "background-color": "#fff" }
          },
          [
            _c(
              "table",
              {
                staticClass:
                  "table table-striped table-hover card-body text-center"
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [_vm._v("분류유형")])
                  ])
                ]),
                _vm._l(_vm.data.list, function(item) {
                  return _c("tr", { key: item.categoryName }, [
                    _c("td", { staticClass: "align-middle text-left" }, [
                      _vm._v(_vm._s(item.categoryName) + " ")
                    ]),
                    _c(
                      "td",
                      { staticClass: "text-right" },
                      [
                        _c("b-button-group", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary  mb-2",
                              on: {
                                click: function($event) {
                                  return _vm.remove(item.seq)
                                }
                              }
                            },
                            [_vm._v("삭제")]
                          )
                        ])
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }